import {tns} from 'tiny-slider/src/tiny-slider';

function imageSliderAlt() {
	const blocks = document.querySelectorAll('.block-image-slider-alt__images');

	if (blocks) {
		blocks.forEach(block => {
			const options = {
				'container': block,
				'controls': true,
				'controlsText': ['', ''],
				'nav': true,
				'mouseDrag': true,
				'navPosition': 'bottom',
				'responsive': {
					'993': {
						'items': 2,
						'edgePadding': 100,
					},
					'240': {
						'items': 1,
						'edgePadding': 50,
					}
				}
			};

			const slider = tns(options);
		});
	}
}

export default imageSliderAlt;